export const TableColumn = [
    { data: '0', Title: '#', width: 10, position: 1 },
    { data: '1', Title: 'Item', position: 2 },
    { data: '2', Title: 'Type Usages', position: 3 },
    { data: '3', Title: 'Quantity', position: 4 },
    { data: '5', Title: 'Required On/Before', position: 6 },
    { data: '4', Title: 'Requisition By', position: 5 },
    { data: '6', Title: 'Description', position: 7 }, 
    { data: '7', Title: 'Status', position: 8 },
];